import { Component } from '@angular/core';
import { uniqueIncreasing } from '@utils/utils';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import $ from 'jquery';

@Component({
  selector: 'wsb-sms-detail-render',
  templateUrl: './sms-detail-render.component.html',
  styleUrls: ['./sms-detail-render.component.scss'],
  standalone: false
})
export class SmsDetailRenderComponent implements ICellRendererAngularComp {
  params;
  uniqueId = uniqueIncreasing();
  hide = false;
  icon;
  recipients;
  lowQualitySms;

  constructor() {}

  agInit(params): void {
    this.params = params;
    this.recipients = this.params?.data?.recipients;
    this.hide = this.params.hide && this.params.hide instanceof Function ? this.params.hide(params.data) : false;
    this.lowQualitySms = this.params?.data?.idMessageType === 'SI' || this.params?.data?.idMessageType === 'TI' ? true : false;
  }

  refresh(params?: any): boolean {
    return true;
  }

  dropdownClick(rowIndex, uniqueId) {
    const grid = $(this.params.eGridCell).parents('wsb-atlas-grid');
    setTimeout(() => {
      if ($('wsb-sms-detail-render ' + '#atlas-gridgroup-m-' + rowIndex + '-' + uniqueId).length) {
        grid.append($('#atlas-gridgroup-m-' + rowIndex + '-' + uniqueId).detach());
      }
    }, 0);
    $('#atlas-gridgroup-m-' + rowIndex + '-' + uniqueId).css({
      position: 'absolute',
      width: '160px',
      left:
        $('#atlas-gridgroup-' + rowIndex + '-' + uniqueId).offset().left -
        grid.offset().left -
        $('#atlas-gridgroup-m-' + rowIndex + '-' + uniqueId).width() +
        96,
      top: $('#atlas-gridgroup-' + rowIndex + '-' + uniqueId).offset().top - grid.offset().top + 50
    });
  }
}
